export default __webpack_public_path__ + "static/media/loginBCPure.486132bb.jpg";